import * as React from "react";
import type { SVGProps } from "react";
const SvgIconAdd = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" height={48} viewBox="0 96 960 960" width={48} {...props}><path d="M450 856V606H200v-60h250V296h60v250h250v60H510v250h-60Z" /></svg>;
export default SvgIconAdd;